import { gql } from "@apollo/client";

export const MUTATION_CREATE_LOAD = gql`
  mutation CreateLoad(
    $originLocations: [LoadLocationInputType]
    $destinationLocations: [LoadLocationInputType]
    $trailerType: String
    $targetRate: Float
    $weight: Int
    $length: Int
    $timeStart: DateTime
    $timeEnd: DateTime
    $timeDelivery: DateTime
    $postTo: String
    $groupsPostTo: String
    $userLoadNumber: String
    $details: String
  ) {
    createLoad(
      input: {
        originLocations: $originLocations
        destinationLocations: $destinationLocations
        trailerType: $trailerType
        targetRate: $targetRate
        weight: $weight
        length: $length
        timeStart: $timeStart
        timeEnd: $timeEnd
        timeDelivery: $timeDelivery
        postTo: $postTo
        groupsPostTo: $groupsPostTo
        userLoadNumber: $userLoadNumber
        details: $details
      }
    ) {
      load {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        isAutoGeneratedLoadNumber
        modified
        created
        loadId
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_LOAD = gql`
  mutation UpdateLoad(
    $id: ID!
    $originLocations: [LoadLocationInputType]
    $destinationLocations: [LoadLocationInputType]
    $trailerType: String
    $targetRate: Float
    $weight: Int
    $length: Int
    $timeStart: DateTime
    $timeEnd: DateTime
    $timeDelivery: DateTime
    $postTo: String
    $groupsPostTo: String
    $userLoadNumber: String
    $details: String
  ) {
    updateLoad(
      id: $id
      input: {
        originLocations: $originLocations
        destinationLocations: $destinationLocations
        trailerType: $trailerType
        targetRate: $targetRate
        weight: $weight
        length: $length
        timeStart: $timeStart
        timeEnd: $timeEnd
        timeDelivery: $timeDelivery
        postTo: $postTo
        groupsPostTo: $groupsPostTo
        userLoadNumber: $userLoadNumber
        details: $details
      }
    ) {
      load {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        isAutoGeneratedLoadNumber
        modified
        created
        loadId
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_LOAD_AGE = gql`
  mutation UpdateLoad($id: ID!) {
    updateLoad(id: $id, input: {}, refreshPost: true) {
      load {
        id
        timePosted
      }
    }
  }
`;
